import { Pipe, PipeTransform } from '@angular/core';
import { Dates } from '../../common/util/dates';
import { Strings } from '../../common/util/Strings';

@Pipe({ name: 'containerControlLabel' })
export class ContainerControlLabelPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    return obj ? (Strings.equalIgnoreCase("IMMEDIATELY", obj) ? "즉시삭제" : (Strings.equalIgnoreCase("NONE", obj) ? "미사용" : `${Dates.toDateString(new Date(obj))} 이후 삭제`)) : "미사용"
  }
}
